import type { ClientConfig } from './clientConfig.types'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { STORAGE_KEYS } from '@/shared/lib/storage'
import { colesConfig, defaultConfig } from '../clients'

const clientConfigMap: Record<string, ClientConfig> = {
  coles: colesConfig,
  default: defaultConfig,
  // Add more clients as needed
}

interface ClientConfigState {
  clientIdentifier: string | null
  config: ClientConfig
  isLoaded: boolean
  setClientIdentifier: (identifier: string) => void
}

/**
 * NOTE: This data should be fetched in the stateConfig and read from the query.
 * Once the StateConfig is updated in the backend api, remove this hardcoded data.
 */
export const useClientConfigStore = create<ClientConfigState>()(
  persist(set => ({
    clientIdentifier: 'coles', // Default client identifier for Coles
    config: colesConfig, // Use colesConfig as default since clientIdentifier is 'coles'
    isLoaded: false,
    setClientIdentifier: (identifier: string) => {
      const config = clientConfigMap[identifier] || clientConfigMap.coles
      set({
        clientIdentifier: identifier,
        config,
        isLoaded: true,
      })
    },
  }), {
    name: STORAGE_KEYS.CLIENT_CONFIG,
    // Add custom hydration to ensure config matches identifier
    onRehydrateStorage: () => (state) => {
      if (state && state.clientIdentifier) {
        // Ensure the config matches the client identifier
        const correctConfig = clientConfigMap[state.clientIdentifier] || clientConfigMap.coles

        if (state.config !== correctConfig) {
          state.config = correctConfig
          state.isLoaded = true
        }
      }
    },
  }),
)
